<div class="wrapper">
	<div class="part off-value" [class.active]="!checked">
		<i class="fa-solid fa-square-check"></i>
	</div>
	<div class="part on-value" [class.active]="checked">
		<i class="fa-solid fa-times-square"></i>
	</div>
</div>
